<template>
  <default-view>

    <template #header>
      <span>Plates "{{ project_name }}"</span>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon v-on="on" style="margin-left: 8px;">
            mdi-cog
          </v-icon>
        </template>
        <template #default>
          <pre>{{ JSON.stringify(state, null, 2) }}</pre>
        </template>
      </v-tooltip>

      {{ plate_list_checked }}

    </template>

    <template #toolbar-items>

      <!-- filter -->
      <v-toolbar-items style="vertical-align: middle;">

        <v-text-field
          ref="edtFilter" style="margin-top: 6px;"
          clearable dense outlined hide-details
          label="Plate filter" placeholder="regex"
          v-model="filter_field_txt"
          @keypress.enter="edtFilter_keyEnter"
          @keyup.esc="edtFilter_keyEsc"
          @click:clear="edtFilter_keyEsc">
        </v-text-field>
        <v-btn icon ref="btnFilter" @click="btnFilter_click">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-menu v-model="show_filter"
                offset-y :close-on-content-click="false">
          <template #activator="{ on:onMenu }">
            <v-tooltip bottom>
              <template #activator="{ on:onTooltip }">
                <v-btn icon v-on="{ ...onMenu, ...onTooltip }">
                  <v-icon>mdi-filter-menu-outline</v-icon>
                </v-btn>
              </template>
              <span>Filter</span>
            </v-tooltip>
          </template>

          <template #default>
            <v-card style="min-width: 500px;">
              <v-card-text>
                <v-layout row style="white-space: nowrap;" center>

                  <v-col cols="4">
                    <v-radio-group v-model="filter.extra">
                      <v-radio :value="false" label="Sample"></v-radio>
                      <v-radio :value="true" label="Extra"></v-radio>
                      <v-radio :value="-1" label="No filter"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="4">
                    <v-radio-group v-model="filter.failed">
                      <v-radio :value="false" label="No failed"></v-radio>
                      <v-radio :value="true" label="Failed"></v-radio>
                      <v-radio :value="-1" label="No filter"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="4">
                    <v-radio-group v-model="filter.ready">
                      <v-radio :value="true" label="Ready" :disabled="filter.failed === true"></v-radio>
                      <v-radio :value="false" label="Not ready"></v-radio>
                      <v-radio :value="-1" label="No filter"></v-radio>
                    </v-radio-group>
                  </v-col>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="show_filter=false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-menu>

      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items>

        <!-- add new plate -->
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on"
                   style="padding-right: 10px; "
                   @click="btnPlateNew_click">
              <v-badge
                color="green lighten-3"
                ligh avatar bottom overlap>
                <template #default>
                  <v-icon>mdi-table</v-icon>
                </template>
                <template #badge>
                  <v-icon size="20" style="margin-top: -2px;">
                    mdi-plus
                  </v-icon>
                </template>
              </v-badge>
            </v-btn>
          </template>
          <span>Add new plate</span>
        </v-tooltip>
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              v-on="on" icon
              :disabled="plate_list_checked.length === 0"
              @click="btnDelete_click"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <template #default>
            <span>Delete</span>
          </template>
        </v-tooltip>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" @click="btnRefresh_click">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Reload plate list</span>
        </v-tooltip>

      </v-toolbar-items>

    </template>

    <template #content>
      <div style="height: 100%; overflow-y: scroll;">
        <!-- скроллер для списка -->
        <v-container grid-list-md>
          <v-layout row fill-height justify-space-around>

            <template v-for="item in plate_list_filtered">
              <v-flex xs12 sm9 md6 lg4 xl3 :key="item.plate.id" fill-height>
                <plate-list-item
                  :item="item"
                  @checked_changed="ctrlPlateItem_checked_changed"
                  @edit="ctrlPlateItem_edit(item.plate)"
                  @save-projects="ctrlPlateItem_save_projects(item.plate.id, $event)"
                ></plate-list-item>
              </v-flex>

            </template>

          </v-layout>
        </v-container>
      </div>

      <plate-props-dialog
        ref="dlgPlateAdd" :value="show_dlgPlateProps"
        :plate="plate_edit" :new="plate_new"
        @accepted="dlgPlateProps_accepted"
        @closing="dlgPlateProps_closing">
      </plate-props-dialog>

    </template>

  </default-view>
</template>

<script>
	import format from 'string-format'
	import {mapActions, mapGetters} from 'vuex'

	import {Plate} from '../../models/Plate'
	import {PlateItem} from '../../components/plate/PlateListItemComponent'

	import DefaultView from "../app/DefaultView"
	import PlateListItemComponent from "../../components/plate/PlateListItemComponent"
	import PlatePropsDialog from "../../components/plate/PlatePropsDialog"

	export default {
		name: "PlateListView",

		components: {
			DefaultView,
			PlatePropsDialog,
			'plate-list-item': PlateListItemComponent,
		},

		data: function () {
			return {
				project_name: "<NONE>",

				show_filter: false,

				plate_list_filtered: [],
				plate_list_checked: [],

				filter_field_txt: "", // значение в поле ввода

				filter: {
					name_txt: "", // значение, применяемое для фильтрации
					extra: false,
					failed: -1,
					ready: -1,
				},

				show_dlgPlateProps: false,
				plate_edit: null,
				plate_new: false, // создать новую планшету
			}
		},

		watch: {

			project_selected: function (new_value, old_value) {
				console.debug(format("PlateListView.watch.project_selected( {0} )", new_value))
				this.load_data()
			},

			filter: function (new_value, old_value) {
				console.debug("PlateListView.watch.filter() ")
			},

			'filter.extra': function (new_value, old_value) {
				this.update_plate_list_filtered()
			},

			'filter.failed': function (new_value, old_value) {
				this.update_plate_list_filtered()
			},

			'filter.ready': function (new_value, old_value) {
				this.update_plate_list_filtered()
			},

			'filter.name_txt': function (new_value, old_value) {
				this.update_plate_list_filtered()
			},
		},

		computed: {
			...mapGetters({
				projects: 'lists/projects',
				plate_list: 'plate/plate_list',
				plate_filter: 'plate/plate_filter',

				project_selected: 'project/selected',
				// progress_progressing: 'progress/progressing',
			}),

			state: function () {
				const res = JSON.parse(JSON.stringify(this.$data))
				res.plate_list_filtered = format("# {0}", this.plate_list_filtered.length)
				return res
			},
		},

		mounted: function () {
			console.debug("PlateListView.mounted()")
			this.load_data()

			// объект из store нельзя изменять, поэтому
			// копируем значения свойств в данные компонента
			const plate_filter = this.plate_filter
			for (let key in this.filter) {
				this.filter[key] = plate_filter[key]
			}
			this.filter_field_txt = this.filter.name_txt
		},

		methods: {

			...mapActions({
				plate_list_plate: 'plate/list_plate',
				plate_create_plate: 'plate/create_plate',
				plate_update_plate: 'plate/update_plate',
				plate_delete_plates: 'plate/delete_plates',

				plate_set_filter: 'plate/set_filter',

				message_add: 'message/add',
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
			}),

			load_data: function () {
				console.debug("PlateListView.load_data()")

				this.progress_begin({message: "Loading plate list ..."})
				// подождем пока загрузятся справочники
				this.$root.$children[0].lists_promise
					.then(() => {
						console.debug("PlateListView.load_data.lists_promise.then()")

						const current_project = this.projects[this.project_selected]
						this.project_name = current_project ? current_project.name : "<NONE>"

						// Список планшет уже есть в справочниках,
						// дополнительно ничего не надо загружать
						return this.plate_list_plate({project_id: this.project_selected})
					})
					.catch((error) => this.message_add(error))
					.finally(() => {
						this.update_plate_list_filtered()
						this.progress_end()
					})
			},

			update_plate_list_filtered: function () {
				// const me = this
				const re = new RegExp(this.filter.name_txt, 'i')

				this.plate_list_filtered = this.plate_list
					.filter(function (plate) {
						return this.plate_list_checked.indexOf(plate.id) > -1 || (
							(!this.filter.name_txt || re.test(plate.name)) &&
							(this.filter.extra === -1 || plate.extra === this.filter.extra) &&
							(this.filter.failed === -1 || plate.failed === this.filter.failed) &&
							(this.filter.ready === -1 || plate.ready === this.filter.ready)
						)
					}.bind(this))
					.map(plate => new PlateItem(plate, this.plate_list_checked.indexOf(plate.id) > -1))

				this.plate_set_filter({filter: this.filter})

				console.debug("PlateListView.update_plate_list_filtered()")
			},

			create_plate: function (plate) {
				const me = this
				me.progress_begin({message: "Create plate ..."})
				return this.plate_create_plate({plate, details: false})
					.then(() => {
						me.message_add({type: 'success', html: "Plate created."})
					})
					.catch((error) => me.message_add(error))
					.finally(() => {
						// обновляем список планшет в любом случае
						this.update_plate_list_filtered()
						me.progress_end()
					})
			},

			update_plate: function (plate) {
				this.progress_begin({message: "Updating plate ..."})
				return this.plate_update_plate({plate, details: false})
					.then(() => {
						this.message_add({
							type: 'success',
							html: "Plate updated."
						})
					})
					.catch((error) => this.message_add(error))
					.finally(() => this.progress_end())
			},

			delete_plates: function (plate_id_list) {
				this.progress_begin({message: "Deleting plates ..."})
				return this.plate_delete_plates(plate_id_list)
					.then(function (plate_list_deleted) {
						this.message_add({type: 'success', html: "Plates deleted."})

						console.debug(format(
							"PlateListView.delete_plates.then()\n" + "  {0} {1}",
							JSON.stringify(this.plate_list_checked), JSON.stringify(plate_list_deleted)))

						this.plate_list_checked = this.plate_list_checked
							.filter((plate_id) => plate_list_deleted.indexOf(plate_id) === -1)

						console.debug(format(
							"PlateListView.delete_plates.then()\n" + "  {0} {1}",
							JSON.stringify(this.plate_list_checked), JSON.stringify(plate_list_deleted)))

						return this.load_data()
					}.bind(this))
					.catch((error) => this.message_add(error))
					.finally(() => this.progress_end())
			},

			// -- Handle controls' events --

			btnRefresh_click: function (e) {
				console.debug("PlateListView.btnRefresh_click()")
				this.load_data()
			},

			btnDelete_click: function (e) {
				this.delete_plates(this.plate_list_checked)
			},

			edtFilter_keyEnter: function (e) {
				this.filter.name_txt = this.filter_field_txt
			},

			edtFilter_keyEsc: function (e) {
				this.filter.name_txt = this.filter_field_txt = ""
				this.$refs.edtFilter.focus()
			},

			btnFilter_click: function (e) {
				this.filter.name_txt = this.filter_field_txt
				this.$refs.edtFilter.focus()
			},

			btnPlateNew_click: function () {
				this.show_dlgPlateProps = true

				this.plate_new = true
				this.plate_edit = function () {
					const plate = JSON.parse(JSON.stringify(Plate.empty_plate))
					plate.name = null
					// при создании новой планшеты по умолчанию привязываем
					// ее к текущему проекту (это можно изменить при вводе)
					plate.projects = [this.project_selected,]
					return plate
				}.bind(this)()
			},

			dlgPlateProps_accepted: function (event) {
				if (this.plate_new) {
					event.result(this.create_plate(event.inputs))
				} else {
					event.result(this.update_plate(event.inputs))
				}
			},

			dlgPlateProps_closing: function () {
				this.show_dlgPlateProps = false
				this.plate_edit = null
				this.plate_new = false
			},

			ctrlPlateItem_checked_changed: function ({plate, checked}) {
				console.debug(format(
					"PlateListView.ctrlPlateItem_checked_changed( {0} )",
					JSON.stringify({id: plate.id,})
				))

				if (checked) {
					this.plate_list_checked.push(plate.id)
				} else {
					const i = this.plate_list_checked.indexOf(plate.id)
					if (i > -1) {
						this.plate_list_checked.splice(i, 1)
					}
				}
			},

			ctrlPlateItem_edit: function (plate) {
				this.show_dlgPlateProps = true
				this.plate_edit = plate
				this.plate_new = false
			},

			ctrlPlateItem_save_projects: function (plate_id, projects) {
				console.debug("PlateListView.ctrlPlateItem_set_project()")

				const plate = {
					id: plate_id,
					projects: projects,
				}

				this.update_plate(plate)
			},
		},
	}
</script>

<style scoped>

</style>